import { notifyActionPresentationFinished } from '@/components/assistant-ui/action-presentation';

/** Completion outlives its chat pane; only preview/canvas changes are visibility-bound. */
export async function completeWorkspaceTurn<T>(
  event: T,
  callbacks: {
    finishPreview: () => void;
    persistHistory: (event: T) => Promise<unknown> | void;
    isCurrentOwner: () => boolean;
    refreshWorkspace: () => Promise<void> | void;
    threadId?: string;
  },
) {
  callbacks.finishPreview();
  await callbacks.persistHistory(event);
  if (callbacks.threadId) notifyActionPresentationFinished(callbacks.threadId);
  if (callbacks.isCurrentOwner()) void callbacks.refreshWorkspace();
}
